// AGC: TarefasSettings - Sub-page of Settings > Sistema > Tipos de Tarefas
// AGC: Manages built-in + custom task category list (shared with NewTask picker).

import React, { useMemo } from 'react'
import { ClipboardList } from 'lucide-react'
import { CustomListSettingsPage } from './CustomListSettingsPage'
import { useTranslation } from '../../hooks/useTranslation'
import { TASK_CATEGORIES } from '../../types/task'
import type { CustomListItem } from '../inventory/ManageCategoriesUnitsModal'
import type { Screen } from '../../types'

// AGC: Shared storage key — must match the one read by NewTask and other consumers
export const STORAGE_KEY_CUSTOM_TASK_TYPES = 'droidfarm_custom_task_types'

interface TarefasSettingsProps {
  onBack: () => void
  onNavigate: (screen: Screen) => void
}

export const TarefasSettings: React.FC<TarefasSettingsProps> = ({ onBack }) => {
  const { t } = useTranslation()

  const builtInItems = useMemo<CustomListItem[]>(
    () => TASK_CATEGORIES.map((c) => ({ id: c.id, label: `${c.icon} ${c.name}` })),
    []
  )

  return (
    <CustomListSettingsPage
      title={t('profile.settingsTaskTypes')}
      defaultSectionTitle={t('profile.customListDefault')}
      customSectionTitle={t('profile.customListCustom')}
      emptyText={t('profile.customListEmpty')}
      addPlaceholder={t('profile.settingsTaskTypes')}
      builtInItems={builtInItems}
      storageKeyPrefix={STORAGE_KEY_CUSTOM_TASK_TYPES}
      onBack={onBack}
      Icon={ClipboardList}
    />
  )
}
